/* global window:false */
export default {
    notify: function (errorName, errorMessage, metaData, severity) {
        if (!window.Bugsnag) {
            return console.error(errorName, errorMessage, metaData); // eslint-disable-line
        }
        window.Bugsnag.notify(errorName, errorMessage, metaData, severity);
    }
};


// WEBPACK FOOTER //
// ./node_modules/@99designs/utils/platform/bugsnag.js